"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dsCore = require("@irim/ds-core");

var _printLogger = _interopRequireDefault(require("./middlewares/print-logger"));

var _optionFilling = _interopRequireDefault(require("./middlewares/option-filling"));

var _fetchAdapter = _interopRequireDefault(require("./middlewares/fetch-adapter"));

var _socket = _interopRequireDefault(require("./ability/socket"));

var _jsloader = _interopRequireDefault(require("./ability/jsloader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INIT_ABILITY = Symbol('DsNet.initAbility');
const SOCKET_MAP = Symbol('DsNet.socketMap');
const MIDDLEWARES = Symbol('DsNet.middlewares');
const defaultMiddlewares = [_printLogger.default];
const defaultAbilities = ['ajax', 'jsonp'];

class DsNet extends _dsCore.Plugin {
  /** @type {{ [x: string]: Socket }} */

  /** @type Array */

  /** @type Socket */
  constructor(core, props = {}) {
    super(core, props);
    this[SOCKET_MAP] = {};
    this[MIDDLEWARES] = [];
    this.socket = void 0;
    this[INIT_ABILITY](props.abilities || defaultAbilities);
    this[MIDDLEWARES] = props.middlewares || defaultMiddlewares;
  } // 初始化各种能力


  [INIT_ABILITY](abilities) {
    abilities.forEach(ab => {
      if (typeof ab === 'string') {
        ab = [ab, {}];
      }

      _fetchAdapter.default.init(ab[0], ab[1]);
    });
  }

  init() {
    // option filling 默认放到比较靠前的顺序使用
    this.use(_optionFilling.default, -1000);
    this[MIDDLEWARES].forEach(midd => {
      this.use(midd);
    }); // fetch adapter 默认放到比较靠后的顺序使用

    this.use(_fetchAdapter.default, 1000);
  }

  destroy() {
    // 关闭默认的 socket
    if (this.socket && this.socket.readyStateName === 'OPEN') {
      this.socket.close();
    } // 关闭所有已注册的 socket


    for (const name in this[SOCKET_MAP]) {
      if (Object.prototype.hasOwnProperty.call(this[SOCKET_MAP], name)) {
        const socket = this[SOCKET_MAP][name];

        if (socket.readyStateName === 'OPEN') {
          this.closeSocket(name);
        }
      }
    }
  }

  async request(api, options) {
    const {
      response
    } = await this.run(_objectSpread({
      api
    }, options || {}));
    return response;
  }

  register(name, implementation) {
    if (_fetchAdapter.default.typeMapping[name]) {
      throw new Error("Name: ".concat(name, " has been used."));
    }

    _fetchAdapter.default.typeMapping[name] = implementation;
  }

  async sendData(api, options = {}) {
    options.method = options.method || 'POST';
    return await this.request(api, options);
  }
  /**
   * @param {string} url
   * @return {Promise<Socket>}
   */


  initSocket(url) {
    this.socket = new _socket.default({
      url
    });
    return this.socket.open();
  }
  /**
   * @param {string} name
   * @param {string} url
   * @return {Promise<Socket>}
   */


  async createSocket(name, url) {
    const socket = new _socket.default({
      url
    });
    this[SOCKET_MAP][name] = socket;
    return await socket.open();
  }

  async closeSocket(name) {
    const socket = this.getSocket(name);

    if (!socket) {
      throw new Error("socket ".concat(name, " does not exist."));
    }

    if (socket.readyStateName === 'CLOSING') {
      throw new Error("socket ".concat(name, " is closing."));
    }

    if (socket.readyStateName === 'CLOSED') {
      throw new Error("socket ".concat(name, " has been closed."));
    }

    await socket.close();
    delete this[SOCKET_MAP][name];
  }
  /**
   * @param {string} name
   * @return {Socket}
   */


  getSocket(name) {
    return this[SOCKET_MAP][name];
  }

  loadScript(src, options) {
    return (0, _jsloader.default)(src, options);
  }

}

exports.default = DsNet;